/* eslint-disable max-len */
import { ShowInDialogButton as Dialog } from "@react-admin/ra-form-layout";
import { muiColors } from "themes/colors";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

interface MobileFilterModalProps {
  onClose: () => void;
  open: boolean;
  title?: string;
  children: JSX.Element;
}

const MobileFilterModal = ({
  onClose,
  open,
  title = "Confirmation",
  children
}: MobileFilterModalProps) => {
  return (
    <Dialog
      queryOptions={{ enabled: false }}
      title={title}
      label=" "
      fullWidth
      ButtonProps={{
        value: "",
        variant: "contained",
        startIcon: false,
        sx: {
          padding: "0px !important",
          height: "0px !important",
          minWidth: "0px !important",
          visibility: "hidden",
          svg: {
            display: "none"
          }
        }
      }}
      isOpen={Boolean(open)}
      onClose={onClose}
      close={onClose}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: muiColors.paper,
          borderRadius: "8px"
        },
        "& #edit-dialog-title": {
          textAlign: "center",
          textTransform: "uppercase",
          fontFamily: "Inter",
          fontSize: "14px"
        },
        "& .RaFormDialogTitle-closeButton": {
          display: "none"
        }
      }}
    >
      <div className="p-4">
        {children}
        <IconButton
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px"
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </Dialog>
  );
};

export default MobileFilterModal;
